import { render, staticRenderFns } from "./FullScreenGalleryModal.vue?vue&type=template&id=6c8ff3c9&"
import script from "./FullScreenGalleryModal.vue?vue&type=script&lang=ts&"
export * from "./FullScreenGalleryModal.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreenGalleryModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports